// ============================================
// Author						: Prabakaran
// Description			:
// Date							:
// ============================================
import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse, HttpEventType, HttpEvent, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import {
  IApiError, IApiSuccess, IApiResponse, IHttpOptions, requestType, requestServer,
  MlToken, MlUser, MlBranch, MlCompany, MlApiServer, MlAuthServer, MlProvider
} from '../../interface';

import { CookieService } from 'ngx-cookie';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { QueryResult } from 'ts-db-helper';
declare var require: any;

import * as $ from 'jquery';

@Injectable()
export class HttpService {
  // Define the internal Subject we'll use to push the command count
  public pendingCommandsSubject = new Subject<number>();
  public pendingCommandCount = 0;

  // Provide the *public* Observable that clients can subscribe to
  public pendingCommands$: Observable<number>;
  private _url: string;
  private _headers: HttpHeaders;
  private reqLogger: mlReqLogger;
  constructor(private http: HttpClient, private cookie: CookieService, private router: Router, private ngZone: NgZone) {
    this.pendingCommands$ = this.pendingCommandsSubject.asObservable();
    this.reqLogger = new mlReqLogger();
  }

  /**
   * @description
   * @author Prabakaran
   * @template T
   * @param {string} url
   * @param {IHttpOptions} [Options={
   *       RequestType: requestType.Protected,
   *       RequestServer: requestServer.ApiServer
   *     }]
   * @returns {Observable<IApiSuccess<T>>}
   * @memberof ApiClientGuru
   */
  public get<T>(
    url: string,
    Options: IHttpOptions = {
      RequestType: requestType.Protected,
      RequestServer: requestServer.ApiServer
    }
  ): Observable<IApiSuccess<T>> {
    this.setLoading(true);
    this.reqLogger.Url = this._handleUrl(url, Options);
    this.reqLogger.Headers = this._handleHeader(url, Options);
    this.reqLogger.Method = 'GET';
    this.reqLogger.Body = '';
    const apiResponse = this.http
      .get<IApiResponse>(
        this.reqLogger.Url,
        {
          observe: 'body',
          reportProgress: true,
          headers: this._handleHeader(url, Options)
        })
      .map(data => {
        this.setLoading(false);
        return this._SystemicSrvResponse<T>(data);
      }).catch(ex => {
        this.setLoading(false);
        return this._HttpSrvError<T>(ex);
      });
    return apiResponse;
  }
  /**
   * @description
   * @author Prabakaran
   * @template T
   * @param {string} url
   * @param {*} body
   * @param {IHttpOptions} [Options={
   *       RequestType: requestType.Protected,
   *       RequestServer: requestServer.ApiServer
   *     }]
   * @returns {Observable<IApiSuccess<T>>}
   * @memberof ApiClientGuru
   */
  public post<T>(
    url: string,
    body: any,
    Options: IHttpOptions = {
      RequestType: requestType.Protected,
      RequestServer: requestServer.ApiServer
    }
  ): Observable<IApiSuccess<T>> {
    this.setLoading(true);
    this.reqLogger.Url = this._handleUrl(url, Options);
    this.reqLogger.Headers = this._handleHeader(url, Options);
    this.reqLogger.Method = 'GET';
    this.reqLogger.Body = body;
    const JSON = require('circular-json');
    const bodyData = JSON.stringify(body);
    const apiResponse = this.http
      .post<IApiResponse>(
        this.reqLogger.Url,
        bodyData,
        {
          observe: 'body',
          reportProgress: true,
          headers: this._handleHeader(url, Options)
        })
      .map(data => {
        this.setLoading(false);
        return this._SystemicSrvResponse<T>(data);
      }).catch(ex => {
        this.setLoading(false);
        return this._HttpSrvError<T>(ex);
      });
    return apiResponse;
  }
  /**
   * @description
   * @author Prabakaran
   * @template T
   * @param {string} url
   * @param {*} body
   * @param {IHttpOptions} [Options={
   *       RequestType: requestType.Protected,
   *       RequestServer: requestServer.ApiServer
   *     }]
   * @returns {Observable<IApiSuccess<T>>}
   * @memberof ApiClientGuru
   */
  public Upload<T>(
    url: string,
    body: FormData,
    Options: IHttpOptions = {
      RequestType: requestType.Protected,
      RequestServer: requestServer.ApiServer
    }
  ): Observable<IApiSuccess<T>> {
    this.setLoading(true);
    this.reqLogger.Url = this._handleUrl(url, Options);
    this.reqLogger.Headers = this._handleHeader(url, Options);
    this.reqLogger.Method = 'GET';
    this.reqLogger.Body = body;
    const bodyData = body;
    const apiResponse = this.http
      .post<IApiResponse>(
        this.reqLogger.Url,
        bodyData,
        {
          observe: 'body',
          reportProgress: true,
          headers: this._handleHeader(url, Options).delete('Content-Type')
        })
      .map(data => {
        this.setLoading(false);
        return this._SystemicSrvResponse<T>(data);
      }).catch(ex => {
        this.setLoading(false);
        return this._HttpSrvError<T>(ex);
      });
    return apiResponse;
  }
  //#region handle succss
  private _SystemicSrvResponse<T>(data: IApiResponse) {
    const respSuccess: IApiSuccess<T> = new mlApiSuccess<T>();
    const respError: IApiError = new mlApiError();
    // Check for success response
    if (data && data.response === 'success' && data.success) {
      respSuccess.code = data.success.code;
      respSuccess.message = data.success.message;
      respSuccess.result = <T>data.success.result;
    } else if (data && data.response === 'failure' && data.failure) {
      // Check for error response
      respError.code = data.failure.code;
      respError.message = data.failure.message;
      respError.description = data.failure.description;
      respError.trace = data.failure.trace;
      throw Observable.throw(this._SystemicSrvError(respError));
    } else { // consider as unhandled response
    }
    return respSuccess;
  }
  //#endregion

  //#region  handle Error
  private _HttpSrvError<T>(ex) {
    if (ex instanceof HttpErrorResponse) {
      let message = '';
      const code: number = ex.status;
      if (!navigator.onLine) {
        message = 'Please Check Your Internet Connection';
      } else {
        switch (code) {
          case 400:
            message = 'Invalid request body.';
            break;
          case 401:
            message = 'Unauthorized access found.';
            break;
          case 403:
            message = 'Access denied.';
            break;
          case 404:
            message = 'Request orgin not found on server.';
            break;
          case 405:
            message = 'Method not supported.';
            break;
          case 406:
            message = 'The specified response content type is not supported.';
            break;
          case 408:
            message = 'The request timed out.';
            break;
          case 500:
            message = 'Unexpected error.';
            break;
          case 503:
            message = 'Application is down for maintenance.';
            break;
          default:
            break;
        }
        // message = ex.message;
      }

      const failure = new mlApiError();
      failure.code = code;
      failure.message = message;
      return Observable.throw(failure);
    }
    return Observable.throw(ex.error);

  }
  private _SystemicSrvError<T>(ex: mlApiError) {
    let failure = new mlApiError();
    failure = ex;
    if (!navigator.onLine) {
      failure.message = 'Please Check Your Internet Connection';
    } else {
      switch (failure.code) {
        case 1001.01:
          failure.message = 'Unauthorized access found.';
          break;
        default:
          break;
      }
      // message = ex.message;
    }
    return Observable.throw(failure);
  }
  //#endregion

  //#region handle Request
  private _handleUrl(url: string, Options: IHttpOptions): string {
    let _url = url;
    const httpOptions: IHttpOptions = {
      RequestType: requestType.Protected,
      RequestServer: requestServer.ApiServer
    };
    httpOptions.RequestType = (Options && Options.RequestType) ? Options.RequestType : httpOptions.RequestType;
    httpOptions.RequestServer = (Options && Options.RequestServer) ? Options.RequestServer : httpOptions.RequestServer;


    if (httpOptions.RequestServer === requestServer.ApiServer) { // API - SERVER
      _url = this._tokenContext.ApiServer.Url + url;
    } else if (httpOptions.RequestServer === requestServer.AuthServer) { // AUTH - SERVER
      _url = this._tokenContext.AuthServer.Url + url;
    } else {
      _url = url;
    }
    // Clean up any repeating slashes.
    _url = _url.replace(/([^:]\/)\/+/g, '$1');
    // // Clean up any trailing slashes.
    // _url = _url.replace(/\/+$/g, '');
    return _url;
  }
  private _handleHeader(url, Options: IHttpOptions): HttpHeaders {
    const httpOptions: IHttpOptions = {
      RequestType: requestType.Protected,
      RequestServer: requestServer.ApiServer
    };
    httpOptions.RequestType = (Options && Options.RequestType) ? Options.RequestType : httpOptions.RequestType;
    httpOptions.RequestServer = (Options && Options.RequestServer) ? Options.RequestServer : httpOptions.RequestServer;
    let _headers: HttpHeaders = (Options && Options.Headers) ? Options.Headers : new HttpHeaders();
    if (httpOptions.RequestServer === requestServer.ApiServer) { // API - SERVER
      switch (httpOptions.RequestType) {
        case requestType.Guest: // GUEST MODE API
          if (this._tokenContext.AuthServer.AuthKey && this._tokenContext.AuthServer.ProjectKey) {
            _headers = new HttpHeaders()
              .set('Content-Type', 'application/json')
              .set('X-AUTH-KEY', this._tokenContext.AuthServer.AuthKey)
              .set('X-PROJECT-KEY', this._tokenContext.AuthServer.ProjectKey);
          }
          break;
        case requestType.Protected: // PRODUCTED MODE API
          if (this._tokenContext.ApiServer.ApiKey) {
            _headers = new HttpHeaders()
              .set('Content-Type', 'application/json')
              .set('X-API-KEY', this._tokenContext.ApiServer.ApiKey);
          }
          break;
        case requestType.Anonymus: // PRODUCTED MODE API
          if (this._tokenContext.ApiServer.ApiKey) {
            _headers = new HttpHeaders()
              .set('Content-Type', 'application/json');
          }
          break;
      }
    } else if (httpOptions.RequestServer === requestServer.AuthServer) { // API - SERVER
      switch (httpOptions.RequestType) {
        case requestType.Guest: // GUEST MODE API
          if (this._tokenContext.AuthServer.AuthKey && this._tokenContext.AuthServer.ProjectKey) {
            _headers = new HttpHeaders()
              .set('Content-Type', 'application/json')
              .set('X-AUTH-KEY', this._tokenContext.AuthServer.AuthKey)
              .set('X-PROJECT-KEY', this._tokenContext.AuthServer.ProjectKey);
          }
          break;
        case requestType.Protected: // PRODUCTED MODE API
          if (this._tokenContext.AuthServer.AuthKey && this._tokenContext.AuthServer.ProjectKey) {
            _headers = new HttpHeaders()
              .set('Content-Type', 'application/json')
              .set('X-AUTH-KEY', this._tokenContext.AuthServer.AuthKey)
              .set('X-PROJECT-KEY', this._tokenContext.AuthServer.ProjectKey);
          }
          break;
        case requestType.Anonymus: // PRODUCTED MODE API
          if (this._tokenContext.AuthServer.AuthKey && this._tokenContext.AuthServer.ProjectKey) {
            _headers = new HttpHeaders()
              .set('Content-Type', 'application/json');
          }
          break;
      }
    }
    return _headers;
  }
  //#endregion


  //#region helper class
  private _navigateToSignIn() {
    this.router.navigate(['auth/login']);
  }
  private _navigateToError(url: string) {
    this.router.navigate([url]);
  }
  private get _tokenContext(): MlToken {
    const appConfig = new MlToken();
    try {
      appConfig.UserInfo = (<MlUser>this.cookie.getObject('Config.UserInfo'));
      appConfig.BranchInfo = (<MlBranch>this.cookie.getObject('Config.BranchInfo'));
      appConfig.CompanyInfo = (<MlCompany>this.cookie.getObject('Config.CompanyInfo'));
      appConfig.ApiServer = (<MlApiServer>this.cookie.getObject('Config.ApiServer'));
      appConfig.AuthServer = (<MlAuthServer>this.cookie.getObject('Config.AuthServer'));
      appConfig.Provider = (<MlProvider>this.cookie.getObject('Config.Provider'));
    } catch (error) {

    }
    return appConfig;
  }
  public setLoading(enable) {
    const body = $('body');
    if (enable) {
      this.pendingCommandsSubject.next(++this.pendingCommandCount);
      $(body).addClass('m-page--loading-non-block');
    } else if (this.pendingCommandCount > 0) {
      this.pendingCommandsSubject.next(--this.pendingCommandCount);
      if (this.pendingCommandCount === 0) {
        $(body).removeClass('m-page--loading-non-block');
      }
    }
  }
  //#endregion
}




class mlApiResponse<T> implements IApiResponse {
  response: string;
  failure: IApiError;
  success: mlApiSuccess<T>;
}
export class mlApiError implements IApiError {
  code: number | string;
  message: string;
  description: string;
  trace: string;
}
class mlApiSuccess<T> implements IApiSuccess<T> {
  code: number;
  message: String;
  result: T;
}
class mlReqLogger {
  Url: string;
  Headers: HttpHeaders;
  Method: string;
  Body: any;
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/services/http/http.service.ts